/**
 * API Service Index
 * Re-exports all API modules
 */

// Core utilities
export {
  API_BASE_URL,
  setAuthToken,
  setWorkspaceId,
  getAuthToken,
  getWorkspaceId,
  hasRefreshToken,
  refreshSession,
  onApiError,
  apiRequest,
  ApiRequestError,
  type ApiError
} from './core.js';

// Convenience client
export { apiClient } from '../apiClient';

// Auth & Workspace
export { authApi, workspacesApi, userProfileApi } from './authApi.js';
export type { UserProfile } from './authApi.js';

// CRM
export { customersApi, segmentsApi } from './customerApi.js';

// Commerce
export { ordersApi, productsApi } from './orderApi.js';

// Marketing
export { campaignsApi, flowsApi, emailsApi } from './campaignApi.js';

// Chat flows (WhatsApp / Instagram / Messenger — Unified Agent)
export { chatFlowsApi } from './chatFlowApi.js';
export type {
  ChatFlow,
  ChatFlowNode,
  ChatFlowEdge,
  ChatFlowStatus,
  ChatFlowType,
  ChatFlowAnalytics,
  ChatFlowCreatePayload,
  ChatFlowUpdatePayload,
} from './chatFlowApi.js';

// Integrations & Operations
export { integrationsApi, settingsApi } from './integrationApi.js';
export { broadcastApi } from './broadcastApi.js';
export type { Broadcast, BroadcastChannel, BroadcastStatus, BroadcastPageMeta, CreateBroadcastPayload } from './broadcastApi.js';

// Users, Analytics & AI
export { inboxApi, teamApi, procurementApi } from './settingsApi.js';

// Dashboard
export { dashboardApi } from './dashboardApi.js';

// Popups, Social & Marketing
export { popupsApi, socialApi, marketingApi, vendorApi } from './billingApi.js';

// TikTok
export { tiktokApi } from './tiktokApi.js';

// Automation Engine
export { automationsApi } from './automationsApi.js';
export type { AutomationDetail, AutomationNode, AutomationEdge } from './automationsApi.js';

// BYO-Claude relay
export { agentRelayApi } from './agentApi.js';
export type {
  AgentStatus,
  AgentConnectBody,
  AgentConnectResult,
  AgentStreamEvent,
  AgentChatParams,
  AgentChatSession,
  AgentSessionMessage,
  AgentToolEvent,
} from './agentApi.js';

// Default export with all APIs grouped
import { authApi, workspacesApi, userProfileApi } from './authApi.js';
import { customersApi, segmentsApi } from './customerApi.js';
import { ordersApi, productsApi } from './orderApi.js';
import { campaignsApi, flowsApi, emailsApi } from './campaignApi.js';
import { chatFlowsApi } from './chatFlowApi.js';
import { integrationsApi, settingsApi } from './integrationApi.js';
import { inboxApi, teamApi, procurementApi } from './settingsApi.js';
import { dashboardApi } from './dashboardApi.js';
import { popupsApi, socialApi, marketingApi, vendorApi } from './billingApi.js';
import { tiktokApi } from './tiktokApi.js';
import { automationsApi } from './automationsApi.js';
import { setAuthToken, setWorkspaceId, getAuthToken, getWorkspaceId, hasRefreshToken, refreshSession } from './core.js';

export default {
  auth: authApi,
  workspaces: workspacesApi,
  userProfile: userProfileApi,
  dashboard: dashboardApi,
  customers: customersApi,
  products: productsApi,
  orders: ordersApi,
  campaigns: campaignsApi,
  integrations: integrationsApi,
  flows: flowsApi,
  chatFlows: chatFlowsApi,
  segments: segmentsApi,
  emails: emailsApi,
  inbox: inboxApi,
  settings: settingsApi,
  team: teamApi,
  procurement: procurementApi,
  marketing: marketingApi,
  vendor: vendorApi,
  popups: popupsApi,
  social: socialApi,
  tiktok: tiktokApi,
  automations: automationsApi,
  setAuthToken,
  setWorkspaceId,
  getAuthToken,
  getWorkspaceId,
  hasRefreshToken,
  refreshSession
};
